var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.848 1.14062C5.77398 1.14062 3.28 3.68297 3.28 6.79876V9.70435H2.799C1.66507 9.70435 0.75 10.6408 0.75 11.7828V20.5235C0.75 21.6664 1.66498 22.603 2.799 22.603H14.896C16.03 22.603 16.945 21.6664 16.945 20.5235V11.7828C16.945 10.6397 16.0298 9.70435 14.896 9.70435H14.416V6.79876C14.416 3.68297 11.922 1.14062 8.848 1.14062ZM4.499 6.79876C4.499 4.35485 6.45405 2.37181 8.848 2.37181C11.242 2.37181 13.197 4.35387 13.197 6.79876V9.70435H4.499V6.79876ZM14.897 10.9366C15.35 10.9366 15.726 11.3129 15.726 11.7838V20.5245C15.726 20.9955 15.35 21.3718 14.897 21.3718H2.799C2.34602 21.3718 1.97 20.9955 1.97 20.5245V11.7838C1.97 11.3129 2.34602 10.9366 2.799 10.9366H3.889H13.806H14.897Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84795 12.543C7.62295 12.543 6.62695 13.5558 6.62695 14.8016C6.62695 15.5847 7.02095 16.2955 7.66795 16.7074V18.5562C7.66795 19.2182 8.19695 19.7562 8.84795 19.7562C9.49895 19.7562 10.028 19.2182 10.028 18.5562V16.7074C10.675 16.2955 11.069 15.5847 11.069 14.8016C11.069 13.5569 10.073 12.543 8.84795 12.543ZM9.50895 16.1653C9.38595 16.2274 9.30895 16.3545 9.30895 16.4938V18.5572C9.30895 18.8155 9.10195 19.026 8.84795 19.026C8.59395 19.026 8.38695 18.8155 8.38695 18.5572V16.4938C8.38695 16.3545 8.30895 16.2274 8.18695 16.1653C7.66795 15.905 7.34595 15.3823 7.34595 14.8026C7.34595 13.9606 8.01995 13.2752 8.84795 13.2752C9.67595 13.2752 10.35 13.9606 10.35 14.8026C10.35 15.3823 10.028 15.905 9.50895 16.1653Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGrey);
export default __webpack_public_path__ + "static/media/lock-grey.4a151f08998045b8c55762af7b748049.svg";
export { ForwardRef as ReactComponent };